import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../webgl/BufferObject.js";
import e from "../../../webgl/VertexArrayObject.js";

var r = /*#__PURE__*/function () {
  function r(_r, i) {
    _classCallCheck(this, r);

    this.rctx = _r, this._vertexBuffer = t.createVertex(_r, 35044, new Uint16Array(i)), this._vao = new e(_r, new Map([["a_position", 0]]), {
      geometry: [{
        name: "a_position",
        count: 2,
        type: 5122,
        offset: 0,
        stride: 4,
        normalized: !1
      }]
    }, {
      geometry: this._vertexBuffer
    }), this._count = i.length / 2;
  }

  _createClass(r, [{
    key: "bind",
    value: function bind() {
      this._vao.bind();
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this._vao.unbind();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._vao.dispose(!1), this._vertexBuffer.dispose();
    }
  }, {
    key: "draw",
    value: function draw() {
      this.rctx.bindVAO(this._vao), this.rctx.drawArrays(5, 0, this._count);
    }
  }]);

  return r;
}();

export { r as default };